import script from "./otherStyleCardItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./otherStyleCardItem.vue?vue&type=script&lang=ts&setup=true"

import "./otherStyleCardItem.vue?vue&type=style&index=0&id=2ad94b56&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad94b56"]])

export default __exports__